import React, { ComponentType, HTMLAttributes } from 'react';
import { styled } from '@mui/material/styles';

const Toolbox: ComponentType<HTMLAttributes<HTMLSpanElement>> = styled('div')({
  position: 'absolute',
  bottom: '20px',
  zIndex: 10,
  display: 'flex',
  gap: '4px',
  borderRadius: '6px',
  padding: '5px',
  border: '1px solid #E7E7E7',
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  ':hover': {
    backgroundColor: 'rgba(255, 255, 255, 1)',
  },
  boxShadow: '0px 0px 10px 0px #0000001A',
});

export default Toolbox;
